import * as React from 'react'
import getAuthToken from '../modules/get_auth_token'
import DemoGuardedButton from '../shared/demoGuardedButton'

// TODO: These two constants should be populated via config/initializers/omniauth.rb
export const AUTH_GOOGLE_ONLINE_ACCESS_PATH = "/auth/google/online_access"
export const AUTH_GOOGLE_OFFLINE_ACCESS_PATH = "/auth/google/offline_access"

const AuthGoogleAccessForm = ({
  buttonClass = '',
  formClass = '',
  offlineAccess = false,
  showIcon = true,
  spanClass = '',
  text
}) => {
  const action = offlineAccess ? AUTH_GOOGLE_OFFLINE_ACCESS_PATH : AUTH_GOOGLE_ONLINE_ACCESS_PATH
  const formRef = React.useRef<HTMLFormElement>(null)

  function handleSubmit() {
    formRef.current?.submit()
  }

  return (
    <form
      action={action}
      className={formClass}
      method="post"
      ref={formRef}
    >
      <input name="authenticity_token" type="hidden" value={getAuthToken()} />
      <DemoGuardedButton className={buttonClass} onClick={handleSubmit}>
        {showIcon && <img alt="Google icon" src={`${window.postbuildEnv.CDN_URL}/images/shared/google_icon.svg`} />}
        <span className={spanClass}>{text}</span>
      </DemoGuardedButton>
    </form>
  )
}

export default AuthGoogleAccessForm
